'use strict';

const CONST = require('plugin_frontend_core/constants');

module.exports = {
    addToWishlist: function () {
        $(document).on(CONST.events.click, CONST.selectors.product.addToWishlist, function clickAddToWishlist(e) {
            e.preventDefault();
            
            const $self = $(this);
            const $productContainer = $self.closest(CONST.selectors.product.jsProductContainer);
            let isReady = true;

            // Loop over all attributes
            const $productAttributes = $productContainer.find(CONST.selectors.product.attributes.container);

            $productAttributes.each(function () {
                const $productAttribute = $(this);
                const hasAttributeItems = $productAttribute.find(CONST.selectors.product.attributes.item).length > 0; // does the attribute have any items/variations?
                const noSelectedAttribute = $productAttribute.find(CONST.selectors.product.attributes.selected).length === 0; // does the attribute not have a selected item/variation?
                const $productAttributeMessage = $productContainer.find(CONST.selectors.product.availabilityMsg);
                
                if (hasAttributeItems && noSelectedAttribute) {
                    $productAttribute.addClass(CONST.classes.product.attributes.errorState);
                    $productAttributeMessage.removeClass(CONST.classes.dNone);
                    isReady = false;
                }
            });

            if (!isReady) {
                return false;
            }

            const pid = $productContainer.attr(CONST.attributes.product.productID);
            const urlAdd = $self.attr(CONST.attributes.urlAdd);
            const urlRemove = $self.attr(CONST.attributes.urlRemove);
            const optionId = $productContainer.find(CONST.selectors.product.productOption).attr(CONST.attributes.product.optionID) || null;
            const optionVal = $productContainer.find(CONST.selectors.product.productOptionSelected).attr(CONST.attributes.product.valueID) || null;


            const addToWishlistData = {
                origin: 'wishlist.js',
                optionId: optionId,
                optionVal: optionVal,
                pid: pid,
                trigger: $self,
                urlAdd: urlAdd,
                urlRemove: urlRemove
            };

            window.pubSub.publish(CONST.pubSubEvents.wishlist.clickAddToWishlist, addToWishlistData);
        });
    }
};
